const { hasChild } = require('./hasChild');

function calculateTaskType(taskId, gantt) {
  return taskId < 0 ? 'project_bar' : hasChild(taskId, gantt) ? 'parent_task' : 'task';
}

module.exports = { calculateTaskType };
